import BookingTransactionFormLayout, { transformValues } from './form'
import GenericCreateForm from '../common/create'

export default () => (
  <GenericCreateForm formLayoutComponent={<BookingTransactionFormLayout />} transformValues={transformValues} />
)
